import { render } from "./MainBtn.vue?vue&type=template&id=6196576c&scoped=true"
import script from "./MainBtn.vue?vue&type=script&lang=js"
export * from "./MainBtn.vue?vue&type=script&lang=js"

import "./MainBtn.vue?vue&type=style&index=0&id=6196576c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6196576c"

export default script